
import { defineComponent } from 'vue';
import ExplorerIcon from './ExplorerIcon.vue';

export default defineComponent({
  name: 'ExplorerButton',
  components: { ExplorerIcon },
  props: {
    text: { type: String, required: true },
    icon: { type: String, default: '' },
    textFirst: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isInactive: { type: Boolean, default: false },
  },
  emits: ['click'],
});
